// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Card        = require("./Card");
var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var Utils       = require("./Utils");
var React       = require("react");
var Option      = require("./Option");
var $$String    = require("bs-platform/lib/js/string.js");
var CardList    = require("./CardList");
var Js_boolean  = require("bs-platform/lib/js/js_boolean.js");
var Pervasives  = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var component = ReasonReact.statelessComponent("Form");

function make(onSubmit, $staropt$star, children) {
  var className = $staropt$star ? $staropt$star[0] : "";
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.createDomElement("form", {
                  onSubmit: (function ($$event) {
                      $$event.preventDefault();
                      return Curry._1(onSubmit, $$event);
                    }),
                  className: className
                }, children);
    });
  return newrecord;
}

var Form = /* module */[
  /* component */component,
  /* make */make
];

var component$1 = ReasonReact.statelessComponent("Button.Submit");

function make$1(disabled, $staropt$star, children) {
  var className = $staropt$star ? $staropt$star[0] : "";
  var newrecord = component$1.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.createDomElement("button", {
                  type: "submit",
                  disabled: Js_boolean.to_js_boolean(disabled),
                  className: "pointer button-reset bg-green bn near-white br2 hover-bg-dark-green " + className
                }, children);
    });
  return newrecord;
}

var Submit = /* module */[
  /* component */component$1,
  /* make */make$1
];

var Button = /* module */[/* Submit */Submit];

var component$2 = ReasonReact.statelessComponent("Header");

function make$2() {
  var newrecord = component$2.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "relative h-40px flex-none flex items-center justify-center bg-dark-green shadow-1"
                }, React.createElement("span", {
                      className: "f3 near-white"
                    }, "Reason Trello"));
    });
  return newrecord;
}

var AppHeader = /* module */[
  /* component */component$2,
  /* make */make$2
];

var component$3 = ReasonReact.statelessComponent("BoardHeader");

function make$3(boardName, openForm, _) {
  var newrecord = component$3.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "relative h-30px flex-none flex items-center justify-start pa2"
                }, React.createElement("span", {
                      className: "f4 fw7 helvetica near-white hover-bg-dark-green pa2 br2 pointer",
                      onClick: openForm
                    }, boardName));
    });
  return newrecord;
}

var BoardHeader = /* module */[
  /* component */component$3,
  /* make */make$3
];

var component$4 = ReasonReact.statelessComponent("Container");

function make$4(onMouseMove, onMouseUp, drag, onKeyDown, children) {
  var newrecord = component$4.slice();
  newrecord[/* render */9] = (function () {
      var match = Option.isSome(drag);
      return ReasonReact.createDomElement("div", {
                  className: "h-100 flex flex-column bg-green" + (
                    match !== 0 ? " pointer" : ""
                  ),
                  onMouseMove: onMouseMove,
                  onMouseUp: onMouseUp,
                  onKeyDown: onKeyDown
                }, children);
    });
  return newrecord;
}

var Container = /* module */[
  /* component */component$4,
  /* make */make$4
];

var component$5 = ReasonReact.statelessComponent("CardList");

function make$5(list, $staropt$star, $staropt$star$1, $staropt$star$2, isEditingName, changeListName, openForm, closeForm, viewCard, setInputRef, children) {
  var showPlaceholderOnly = $staropt$star ? $staropt$star[0] : /* false */0;
  var onMouseEnter = $staropt$star$1 ? $staropt$star$1[0] : (function () {
        return /* () */0;
      });
  var onMouseDown = $staropt$star$2 ? $staropt$star$2[0] : (function () {
        return /* () */0;
      });
  var newrecord = component$5.slice();
  newrecord[/* render */9] = (function () {
      var arr = $$Array.of_list(List.mapi(viewCard, list[/* cards */2]));
      return React.createElement("div", {
                  key: CardList.cidToString(list[/* cid */0]),
                  className: "flex flex-column ml2 mr1 w5 flex-none",
                  onMouseEnter: onMouseEnter
                }, React.createElement("div", {
                      className: "bg-dark-green br2 flex flex-column"
                    }, React.createElement("div", {
                          className: "flex flex-column",
                          style: {
                            visibility: showPlaceholderOnly !== 0 ? "hidden" : "inherit"
                          }
                        }, React.createElement("div", {
                              className: "flex-none br2 br--top pa1 ma0 pa2 bg-moon-gray pointer"
                            }, isEditingName !== 0 ? ReasonReact.element(/* None */0, /* None */0, make((function () {
                                          return Curry._1(closeForm, /* () */0);
                                        }), /* Some */["flex"], /* array */[
                                        React.createElement("input", {
                                              ref: setInputRef,
                                              className: "br2 ba b--gray input-reset flex-auto",
                                              value: list[/* name */1],
                                              onBlur: (function () {
                                                  return Curry._1(closeForm, /* () */0);
                                                }),
                                              onChange: changeListName
                                            }),
                                        React.createElement("button", {
                                              className: "dn",
                                              disabled: Js_boolean.to_js_boolean(+($$String.trim(list[/* name */1]).length === 0)),
                                              type: "submit"
                                            })
                                      ])) : React.createElement("h3", {
                                    className: "f5 helvetica ma0 pa0 dark-gray user-select-none min-h2",
                                    onClick: (function () {
                                        return Curry._1(openForm, /* () */0);
                                      }),
                                    onMouseDown: onMouseDown
                                  }, list[/* name */1])), React.createElement("div", {
                              className: "flex-auto overflow-y-scroll flex flex-column-reverse bg-moon-gray br2 br--bottom"
                            }, ReasonReact.createDomElement("div", { }, $$Array.append(arr, children))))));
    });
  return newrecord;
}

var CardList$1 = /* module */[
  /* component */component$5,
  /* make */make$5
];

var component$6 = ReasonReact.statelessComponent("Card");

function make$6(card, onDragStart, onMouseEnter, $staropt$star, _) {
  var showPlaceholderOnly = $staropt$star ? $staropt$star[0] : /* false */0;
  var newrecord = component$6.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "bg-gray br2 mb2 ml1 mr1 mt0"
                }, React.createElement("div", {
                      key: Card.cidToString(card[/* cid */0]),
                      className: "bg-white-90 br2 pa2 helvetica f6 dark-gray bb b--silver user-select-none pointer",
                      style: {
                        visibility: showPlaceholderOnly !== 0 ? "hidden" : "inherit"
                      },
                      onMouseDown: onDragStart,
                      onMouseEnter: onMouseEnter
                    }, card[/* name */1]));
    });
  return newrecord;
}

var Card$1 = /* module */[
  /* component */component$6,
  /* make */make$6
];

var component$7 = ReasonReact.statelessComponent("NewCardForm.OpenButton");

function make$7(openForm, _) {
  var newrecord = component$7.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "flex-none flex"
                }, React.createElement("button", {
                      className: "bg-transparent b--transparent button-reset pointer flex flex-auto hover-bg-black-10 pa2 f6 user-select-none",
                      onClick: openForm
                    }, "Add a card..."));
    });
  return newrecord;
}

var OpenButton = /* module */[
  /* component */component$7,
  /* make */make$7
];

var component$8 = ReasonReact.statelessComponent("NewCardForm.OpenedForm");

function make$8(newCardName, changeNewCardName, addCard, closeForm, setInputRef, _) {
  var newrecord = component$8.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.element(/* None */0, /* None */0, make(addCard, /* Some */["flex-none flex flex-column"], /* array */[
                      React.createElement("div", {
                            className: "bg-white-90 br2 mb2 ml1 mr1 mt0 pa2 h3"
                          }, React.createElement("input", {
                                ref: setInputRef,
                                className: "bn bg-transparent input-reset outline-0",
                                value: newCardName,
                                onChange: changeNewCardName
                              })),
                      React.createElement("div", {
                            className: "flex flex-row items-center justify-start pl1 pb2"
                          }, ReasonReact.element(/* None */0, /* None */0, make$1(+($$String.trim(newCardName).length === 0), /* Some */["h2 w3 fw7 ml0 mr1"], /* array */["Add"])), React.createElement("button", {
                                className: "bg-transparent bn pointer button-reset light-silver hover-dark-gray f3",
                                type: "button",
                                onClick: closeForm
                              }, "X"))
                    ]));
    });
  return newrecord;
}

var OpenedForm = /* module */[
  /* component */component$8,
  /* make */make$8
];

var component$9 = ReasonReact.statelessComponent("NewCardForm");

function make$9(newCardForm, changeNewCardName, listCid, addCard, openForm, closeForm, setInputRef, _) {
  var newrecord = component$9.slice();
  newrecord[/* render */9] = (function () {
      if (newCardForm) {
        var newCardForm$1 = newCardForm[0];
        if (listCid === newCardForm$1[/* listCid */0]) {
          return ReasonReact.element(/* None */0, /* None */0, make$8(newCardForm$1[/* name */1], changeNewCardName, addCard, closeForm, setInputRef, /* array */[]));
        } else {
          return ReasonReact.element(/* None */0, /* None */0, make$7(openForm, /* array */[]));
        }
      } else {
        return ReasonReact.element(/* None */0, /* None */0, make$7(openForm, /* array */[]));
      }
    });
  return newrecord;
}

var NewCardForm = /* module */[
  /* OpenButton */OpenButton,
  /* OpenedForm */OpenedForm,
  /* component */component$9,
  /* make */make$9
];

var component$10 = ReasonReact.statelessComponent("AddListForm.OpenButton");

function make$10(openForm, _) {
  var newrecord = component$10.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("button", {
                  className: "bg-dark-green bn button-reset pointer br2 h2 pt1 pb1 pl2 white-80 w5 flex flex-none",
                  placeholder: "Add a list...",
                  onClick: openForm
                }, "Add a list...");
    });
  return newrecord;
}

var OpenButton$1 = /* module */[
  /* component */component$10,
  /* make */make$10
];

var component$11 = ReasonReact.statelessComponent("AddListForm.OpenedForm");

function make$11(addList, newListName, changeNewListName, closeForm, setInputRef, _) {
  var newrecord = component$11.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.element(/* None */0, /* None */0, make(addList, /* Some */["flex flex-column self-start br2 pa1 ma0 pa2 bg-moon-gray"], /* array */[
                      React.createElement("input", {
                            ref: setInputRef,
                            className: "outline-0 input-reset ba b--gray br2 h1 pt1 pb1 pl2 mb2 w5",
                            placeholder: "Add a list...",
                            value: newListName,
                            onChange: changeNewListName
                          }),
                      React.createElement("div", {
                            className: "flex flex-row justify-start items-center"
                          }, React.createElement("button", {
                                className: "h2 w3 pointer button-reset bg-green bn near-white fw7 br2 hover-bg-dark-green mr1",
                                disabled: Js_boolean.to_js_boolean(+($$String.trim(newListName).length === 0)),
                                type: "submit"
                              }, "Save"), React.createElement("button", {
                                className: "bg-transparent bn pointer button-reset light-silver hover-dark-gray f3",
                                type: "button",
                                onClick: closeForm
                              }, "X"))
                    ]));
    });
  return newrecord;
}

var OpenedForm$1 = /* module */[
  /* component */component$11,
  /* make */make$11
];

var component$12 = ReasonReact.statelessComponent("AddListForm");

function make$12(newListForm, addList, changeNewListName, openForm, closeForm, setInputRef, _) {
  var newrecord = component$12.slice();
  newrecord[/* render */9] = (function () {
      var match = newListForm[/* isOpen */1];
      if (match !== 0) {
        return ReasonReact.element(/* None */0, /* None */0, make$11(addList, newListForm[/* name */0], changeNewListName, closeForm, setInputRef, /* array */[]));
      } else {
        return ReasonReact.element(/* None */0, /* None */0, make$10(openForm, /* array */[]));
      }
    });
  return newrecord;
}

var AddListForm = /* module */[
  /* OpenButton */OpenButton$1,
  /* OpenedForm */OpenedForm$1,
  /* component */component$12,
  /* make */make$12
];

function initialState() {
  return /* record */[/* containerRef */[/* None */0]];
}

function reducer(_, _$1) {
  return /* NoUpdate */0;
}

function handleClickOutside(self, callback, domEvent) {
  var match = self[/* state */2][/* containerRef */0][0];
  if (match) {
    var target = Curry._1(Utils.Dom[/* domEventToObj */4], domEvent).target;
    var match$1 = 1 - +match[0].contains(target);
    if (match$1 !== 0) {
      return Curry._1(callback, /* () */0);
    } else {
      return /* () */0;
    }
  } else {
    return /* () */0;
  }
}

var component$13 = ReasonReact.reducerComponent("ClickOutsideWrapper");

function make$13(onClickOutside, children) {
  var newrecord = component$13.slice();
  newrecord[/* didMount */4] = (function (self) {
      Curry._2(Utils.Dom[/* addEventListener */2], "click", (function ($$event) {
              return handleClickOutside(self, onClickOutside, $$event);
            }));
      return /* NoUpdate */0;
    });
  newrecord[/* willUnmount */6] = (function (self) {
      return Curry._2(Utils.Dom[/* removeEventListener */3], "click", (function ($$event) {
                    return handleClickOutside(self, onClickOutside, $$event);
                  }));
    });
  newrecord[/* render */9] = (function (param) {
      return ReasonReact.createDomElement("div", {
                  ref: Curry._1(param[/* handle */0], (function (theRef, param) {
                          param[/* state */2][/* containerRef */0][0] = (theRef == null) ? /* None */0 : [theRef];
                          return /* () */0;
                        }))
                }, children);
    });
  newrecord[/* initialState */10] = initialState;
  newrecord[/* reducer */12] = reducer;
  return newrecord;
}

var ClickOutsideWrapper = /* module */[
  /* initialState */initialState,
  /* reducer */reducer,
  /* handleClickOutside */handleClickOutside,
  /* component */component$13,
  /* make */make$13
];

function initialState$1(boardName) {
  return /* record */[
          /* inputValue */boardName,
          /* containerRef */[/* None */0],
          /* inputRef */[/* None */0]
        ];
}

function reducer$1(action, state) {
  if (action) {
    return /* Update */Block.__(0, [/* record */[
                /* inputValue */action[0],
                /* containerRef */state[/* containerRef */1],
                /* inputRef */state[/* inputRef */2]
              ]]);
  } else {
    return /* SideEffects */Block.__(2, [(function (param) {
                  return Utils.Dom[/* focusAndHighlightElement */1](param[/* state */2][/* inputRef */2]);
                })]);
  }
}

var component$14 = ReasonReact.reducerComponent("EditBoardNamePopup");

function make$14(boardName, closeForm, onSubmit, _) {
  var newrecord = component$14.slice();
  newrecord[/* didMount */4] = (function (param) {
      Curry._2(param[/* reduce */1], (function () {
              return /* FocusInput */0;
            }), /* () */0);
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (param) {
      var state = param[/* state */2];
      var handle = param[/* handle */0];
      return React.createElement("div", {
                  ref: Curry._1(handle, (function (theRef, param) {
                          param[/* state */2][/* containerRef */1][0] = (theRef == null) ? /* None */0 : [theRef];
                          return /* () */0;
                        })),
                  className: "br2 bg-near-white ba b--silver flex flex-column",
                  style: {
                    left: "8px",
                    position: "absolute",
                    top: "90px",
                    width: "300px"
                  }
                }, ReasonReact.element(/* None */0, /* None */0, make$13((function () {
                            return Curry._1(closeForm, /* () */0);
                          }), /* array */[
                          React.createElement("div", undefined, React.createElement("div", {
                                    className: "flex flex-row justify-between items-center ml1 mr1 bb b--moon-gray h2"
                                  }, React.createElement("span", {
                                        style: {
                                          visibility: "hidden"
                                        }
                                      }, "X"), React.createElement("span", {
                                        className: "helvetica f6 gray"
                                      }, "Rename Board"), React.createElement("button", {
                                        className: "bg-transparent bn pointer button-reset light-silver hover-dark-gray f7",
                                        type: "button",
                                        onClick: (function () {
                                            return Curry._1(closeForm, /* () */0);
                                          })
                                      }, "X"))),
                          ReasonReact.element(/* None */0, /* None */0, make((function () {
                                      return Curry._1(onSubmit, state[/* inputValue */0]);
                                    }), /* Some */["flex flex-column ma2"], /* array */[
                                    React.createElement("label", {
                                          className: "pb1 fw7 helvetica f6 dark-gray"
                                        }, "Name"),
                                    React.createElement("input", {
                                          ref: Curry._1(handle, (function (theRef, param) {
                                                  param[/* state */2][/* inputRef */2][0] = (theRef == null) ? /* None */0 : [theRef];
                                                  return /* () */0;
                                                })),
                                          className: "pa2 mb3 br2 input-reset ba b--silver",
                                          value: state[/* inputValue */0],
                                          onChange: Curry._1(param[/* reduce */1], (function ($$event) {
                                                  return /* SetInputValue */[$$event.target.value];
                                                }))
                                        }),
                                    React.createElement("button", {
                                          className: "h2 pointer button-reset bg-green bn near-white fw7 br2 hover-bg-dark-green mr1 self-start mb1 ml1 w4",
                                          disabled: Js_boolean.to_js_boolean(+($$String.trim(state[/* inputValue */0]).length === 0)),
                                          type: "submit"
                                        }, "Rename")
                                  ]))
                        ])));
    });
  newrecord[/* initialState */10] = (function () {
      return initialState$1(boardName);
    });
  newrecord[/* reducer */12] = reducer$1;
  return newrecord;
}

var EditBoardNamePopup = /* module */[
  /* initialState */initialState$1,
  /* reducer */reducer$1,
  /* component */component$14,
  /* make */make$14
];

var component$15 = ReasonReact.statelessComponent("DragWrapper");

function make$15(drag, children) {
  var newrecord = component$15.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.createDomElement("div", {
                  className: "rotate-5 absolute pointer",
                  style: {
                    left: Pervasives.string_of_int(drag[/* mousePosition */3][0] - drag[/* initialClickOffset */2][0] | 0) + "px",
                    top: Pervasives.string_of_int(drag[/* mousePosition */3][1] - drag[/* initialClickOffset */2][1] | 0) + "px",
                    width: "245px",
                    pointerEvents: "none"
                  }
                }, children);
    });
  return newrecord;
}

var DragWrapper = /* module */[
  /* component */component$15,
  /* make */make$15
];

var component$16 = ReasonReact.statelessComponent("DraggedItem");

function make$16(drag, newCardForm, _) {
  var newrecord = component$16.slice();
  newrecord[/* render */9] = (function () {
      if (drag) {
        var drag$1 = drag[0];
        var match = drag$1[/* target */1];
        var match$1 = drag$1[/* movement */0];
        if (match.tag) {
          if (match$1 !== 0) {
            return ReasonReact.element(/* None */0, /* None */0, make$15(drag$1, /* array */[ReasonReact.element(/* None */0, /* None */0, make$6(match[0][/* item */0], (function () {
                                        return /* () */0;
                                      }), (function () {
                                        return /* () */0;
                                      }), /* None */0, /* array */[]))]));
          } else {
            return null;
          }
        } else if (match$1 !== 0) {
          var list = match[0][/* item */0];
          return ReasonReact.element(/* None */0, /* None */0, make$15(drag$1, /* array */[ReasonReact.element(/* None */0, /* None */0, make$5(list, /* None */0, /* None */0, /* None */0, /* false */0, (function () {
                                      return /* () */0;
                                    }), (function () {
                                      return /* () */0;
                                    }), (function () {
                                      return /* () */0;
                                    }), (function (_, card) {
                                      return ReasonReact.element(/* None */0, /* None */0, make$6(card, (function () {
                                                        return /* () */0;
                                                      }), (function () {
                                                        return /* () */0;
                                                      }), /* None */0, /* array */[]));
                                    }), (function () {
                                      return /* () */0;
                                    }), /* array */[ReasonReact.element(/* None */0, /* None */0, make$9(newCardForm, (function () {
                                                return /* () */0;
                                              }), list[/* cid */0], (function () {
                                                return /* () */0;
                                              }), (function () {
                                                return /* () */0;
                                              }), (function () {
                                                return /* () */0;
                                              }), (function () {
                                                return /* () */0;
                                              }), /* array */[]))]))]));
        } else {
          return null;
        }
      } else {
        return null;
      }
    });
  return newrecord;
}

var DraggedItem = /* module */[
  /* component */component$16,
  /* make */make$16
];

exports.Form                = Form;
exports.Button              = Button;
exports.AppHeader           = AppHeader;
exports.BoardHeader         = BoardHeader;
exports.Container           = Container;
exports.CardList            = CardList$1;
exports.Card                = Card$1;
exports.NewCardForm         = NewCardForm;
exports.AddListForm         = AddListForm;
exports.ClickOutsideWrapper = ClickOutsideWrapper;
exports.EditBoardNamePopup  = EditBoardNamePopup;
exports.DragWrapper         = DragWrapper;
exports.DraggedItem         = DraggedItem;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/View.re
// module id = 43
// module chunks = 0